<template>
  <Loader v-if="loader" />
  <div class="card p-3 preavvisi">
    <div class="flex align-items-end justify-content-start">
      <div class="col-12 lg:col-4 flex flex-column align-items-start mb-3">
        <label style="margin-bottom: 10px;">Data scadenza</label>
        <Calendar
          v-model="selectedDate"
          :manualInput="false"
          dateFormat="dd-mm-yy"
          class="inputfield w-full"
        />
      </div>
      <div class="col-12 lg:col-3 flex align-items-end justify-content-start mb-3">
        <Button
          label="Cerca"
          @click="searchData"
          icon="pi pi-search"
          iconPos="left"
          class="custom-button"
        />
      </div>
    </div>
  </div>
  <div v-if="search_loaded">
    <div class="card">
      <!-- <Button icon="pi pi-times" @click="closeCard" class="close-button" /> -->
      <div class="flex align-items-center mb-5">
        <InputText
          @input="onGlobalSearch"
          class="w-full uniform-button-height"
          v-model="searchString"
          type="text"
          placeholder="Cerca..."
           style="height: 38px;"
        />
        <Button
          label="Mostra solo per inviato = NO"
          @click="toggleFilterInvii"
          :class="filterInvii ? 'p-button-success' : ''"
          class="ml-2 p-button-sm" 
          style="height: 38px; min-width: 200px;" 
        />
        <Button
          label="Mostra solo per Sosp.inviata = NO"
          @click="toggleFilterSospInviata"
          :class="filterSospInviata ? 'p-button-success' : ''"
          class="ml-2 p-button-sm"
          style="height: 38px; min-width: 200px;"
          
        />

        <!-- <div class="col-12 lg:col-2 flex align-items-end">
          <div class="button-container">
            <Button
              :label="`Preavvisi da inviare: ${filteredPreavvisiCount}`"
              @click="showFilteredPreavvisi"
              icon="pi pi-exclamation-triangle"
              iconPos="right"
              class="ml-2 uniform-button-height"
              :class="
                filteredPreavvisiCount > 0
                  ? 'p-button-danger'
                  : 'p-button-success'
              "
            />
          </div>
        </div> -->
      </div>

      <TabView
        v-model:activeIndex="activeTab"
        v-if="Object.keys(filteredItems).length != 0"
      >
        <TabPanel
          v-for="(elements, typeClient) in filteredItems"
          :key="typeClient"
          :header="typeClient.toUpperCase()"
        >
          <div class="grid my-2">
            <div class="col-6 lg:col-4">
              <div class="card mb-0" style="padding: 12px 20px">
                <div class="flex justify-content-between mb-2">
                  <div>
                    <span class="block text-500 font-medium mb-3"
                      >TOT.FATTURE</span
                    >
                    <div class="text-900 font-medium text-xl">
                      {{
                        formatCurrency(
                          elements.reduce(
                            (acc, curr) => acc + curr.tot_fatture,
                            0
                          )
                        )
                      }}
                    </div>
                  </div>
                  <div
                    class="flex align-items-center justify-content-center bg-blue-100 border-round"
                    style="width: 2rem; height: 2rem"
                  >
                    <i class="pi pi-file text-blue-500 text-m"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6 lg:col-4">
              <div class="card mb-0" style="padding: 12px 20px">
                <div class="flex justify-content-between mb-2">
                  <div>
                    <span class="block text-500 font-medium mb-3"
                      >TOT.PAGATO</span
                    >
                    <div class="text-900 font-medium text-xl">
                      {{
                        formatCurrency(
                          elements.reduce(
                            (acc, curr) => acc + curr.tot_pagato,
                            0
                          )
                        )
                      }}
                    </div>
                  </div>
                  <div
                    class="flex align-items-center justify-content-center bg-blue-100 border-round"
                    style="width: 2rem; height: 2rem"
                  >
                    <i class="pi pi-file text-blue-500 text-m"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6 lg:col-4">
              <div class="card mb-0" style="padding: 12px 20px">
                <div class="flex justify-content-between mb-2">
                  <div>
                    <span class="block text-500 font-medium mb-3"
                      >TOT.SALDO</span
                    >
                    <div class="text-900 font-medium text-xl">
                      {{
                        formatCurrency(
                          elements.reduce(
                            (acc, curr) => acc + curr.tot_saldo,
                            0
                          )
                        )
                      }}
                    </div>
                  </div>
                  <div
                    class="flex align-items-center justify-content-center bg-blue-100 border-round"
                    style="width: 2rem; height: 2rem"
                  >
                    <i class="pi pi-file text-blue-500 text-m"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="elements.some((el) => !el.pec && !el.email)">
            <Message severity="warn" class="bg-pink-100">
              Attenzione ({{
                elements.filter((el) => !el.pec && !el.email).length
              }}) forniture non hanno indirizzo di contatto
            </Message>
          </div>
          <Accordion lazy multiple>
            <AccordionTab
              v-for="el in elements"
              :key="`${el.id}_${typeClient}`"
              v-show="filteredDetails(el.details).length > 0"
            >
              <template #header>
                <div class="flex justify-content-between flex-wrap w-full">
                  <div class="flex align-items-center flex-column">
                    <div>
                      <span v-if="typeClient == 'agente'">
                        <div>&nbsp;</div>
                        <div>{{ el.agente }}</div>
                        <small>
                          Preavvisi da inviare:
                          {{
                            filteredDetails(el.details).filter(
                              (detail) => detail.is_sent !== "si"
                            ).length
                          }}
                        </small>
                      </span>
                      <span v-else>
                        <div class="text-500 text-xs">{{ el.agente }}</div>
                        <div>{{ el.name }}</div>
                        <small>
                          Preavvisi da inviare:
                          {{
                            filteredDetails(el.details).filter(
                              (detail) => detail.is_sent !== "si"
                            ).length
                          }}
                        </small>
                      </span>
                      <div class="text-400 text-xs">
                        <small
                          >{{ el.max_giorni_ritardo }} giorni di ritardo</small
                        >
                      </div>
                    </div>
                  </div>
                  <i></i>
                  <div class="text-left">
                    <div class="price">
                      <small class="text-400 text-xs">SALDO</small> <br />{{
                        formatCurrency(el.tot_saldo)
                      }}
                    </div>
                    <small class="text-500 text-xs"
                      >Fatture scadute ({{ el.details.length }})</small
                    >
                  </div>
                </div>
              </template>
              <div class="grid my-2">
                <div class="col-6 lg:col-4">
                  <div class="card mb-0" style="padding: 8px 16px">
                    <div class="flex justify-content-between m-2">
                      <div>
                        <span class="block text-500 font-medium text-sm"
                          >TOT.FATTURE:
                          <b>{{
                            formatCurrency(
                              el.details.reduce(
                                (acc, curr) => acc + curr.totale_fattura,
                                0
                              )
                            )
                          }}</b></span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6 lg:col-4">
                  <div class="card mb-0" style="padding: 8px 16px">
                    <div class="flex justify-content-between m-2">
                      <div>
                        <span class="block text-500 font-medium text-sm"
                          >TOT.PAGATO:
                          <b>{{
                            formatCurrency(
                              el.details.reduce(
                                (acc, curr) => acc + curr.pagato,
                                0
                              )
                            )
                          }}</b></span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6 lg:col-4">
                  <div class="card mb-0" style="padding: 8px 16px">
                    <div class="flex justify-content-between m-2">
                      <div>
                        <span class="block text-500 font-medium text-sm"
                          >TOT.SALDO:
                          <b>{{
                            formatCurrency(
                              el.details.reduce(
                                (acc, curr) => acc + curr.saldo,
                                0
                              )
                            )
                          }}</b></span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <DataTable
                :ref="`dt_insoluti_${el.id}_${typeClient}`"
                :value="filteredDetails(el.details)"
                dataKey="numero"
                v-model:selection="selectedItems"
                responsiveLayout="scroll"
                :rowClass="rowClass"
              >
                <template #empty>
                  <div class="text-center">Nessun dato trovato.</div>
                </template>
                <!-- <Column selectionMode="multiple" headerStyle="width: 3rem" /> -->
                <Column
                  field="numero"
                  header="N. Fattura"
                  :sortable="true"
                ></Column>
                <Column
                  field="is_sent"
                  header="Inviato"
                  :sortable="true"
                ></Column>
                <Column
                  field="notificaPreavvisi"
                  header="Invio Automatico"
                ></Column>
                <Column
                  field="in_suspension"
                  header="Sosp.inviata"
                  :sortable="true"
                >
                  <template #body="{ data }">
                    {{ data.in_suspension == 1 ? "SI" : "NO" }}
                  </template>
                </Column>
                <Column
                  field="pdp"
                  header="Fornitura"
                  :sortable="true"
                ></Column>
                <Column
                  field="cliente"
                  header="Cliente"
                  :sortable="true"
                ></Column>
                <Column
                  field="rappresentante"
                  header="Rappresentante"
                  :sortable="true"
                ></Column>
                <Column
                  field="agente"
                  header="Agente"
                  :sortable="true"
                ></Column>
                <Column
                  field="data_scadenza"
                  header="Data Scadenza"
                  :sortable="true"
                >
                  <template #body="{ data }">
                    {{ moment(data.data_scadenza).format("DD-MM-YYYY") }}
                  </template>
                </Column>
                <Column field="dataInvio" header="Data Invio" :sortable="true">
                  <template #body="{ data }">
                    {{
                      data.dataInvio
                        ? moment(data.dataInvio).format("DD-MM-YYYY")
                        : ""
                    }}
                  </template>
                </Column>
                <Column
                  field="saldo"
                  header="Totale Fattura"
                  :sortable="true"
                >
                  <template #body="{ data }">
                    {{ formatCurrency(data.saldo) }}
                  </template>
                </Column>
                <Column field="pagato" header="Pagato" :sortable="true">
                  <template #body="{ data }">
                    {{ formatCurrency(data.pagato) }}
                  </template>
                </Column>
                <Column field="saldo" header="Saldo" :sortable="true">
                  <template #body="{ data }">
                    {{ formatCurrency(data.saldo) }}
                  </template>
                </Column>
                <Column field="saldoCliente" header="Saldo Cliente" :sortable="true">
                  <template #body="{ data }">
                    {{ formatCurrency(data.saldoCliente) }}
                  </template>
                </Column>
                <Column field="contabili" header="Contabili" :sortable="true"></Column>
                <Column field="dilazioni" header="Dilazioni" :sortable="true"></Column>
                <Column field="cmor_tot" header="Cmor" :sortable="true">
                  <template #body="{ data }">
                    {{ formatCurrency(data.cmor_tot) }}
                  </template>
                </Column>
                <Column header="Contatto">
                  <template #body="{ data }">
                    {{ data.pec > "" ? data.pec : data.email }}
                  </template>
                </Column>
                <Column header="">
                  <template #body="{ data }">
                    <Button
                      label="PDF"
                      icon="pi pi-file-pdf"
                      class="mb-auto"
                      @click="onGetPdfButton(data.numero)"
                    />
                  </template>
                </Column>
              </DataTable>
            </AccordionTab>
          </Accordion>
        </TabPanel>
      </TabView>
      <div class="w-full xl:w-6 p-3" v-else>
        <Skeleton class="mb-2"></Skeleton>
        <Skeleton width="10rem" class="mb-2"></Skeleton>
        <Skeleton width="5rem" class="mb-2"></Skeleton>
        <Skeleton height="2rem" class="mb-2"></Skeleton>
        <Skeleton width="10rem" height="4rem"></Skeleton>
      </div>
    </div>
  </div>
  <Dialog
    header="Controllo Invii"
    v-model:visible="dialogCheckPreavvisiSent"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '70vw' }"
  >
    <div class="w-full">
      <DataTable :value="report" responsiveLayout="scroll" :rowClass="rowClass">
        <Column field="cliente" header="Cliente" :sortable="true"></Column>
        <Column
          field="rappresentante"
          header="Rappresentante"
          :sortable="true"
        ></Column>
        <Column header="Contatto" :sortable="true">
          <template #body="{ data }">
            {{ data.pec ?? data.email }}
          </template>
        </Column>
        <Column field="sent" header="Inviata" :sortable="true">
          <template #body="{ data, field }">
            <span v-if="data[field] == true" class="text-green-400">SI</span>
            <span v-else class="p-error">NO</span>
          </template>
        </Column>
        <Column field="sent_err" header="Errore"></Column>
      </DataTable>
    </div>
    <template #footer>
      <Button
        label="Chiudi"
        icon="pi pi-times"
        @click="dialogCheckPreavvisiSent = false"
        class="p-button-text"
      />
    </template>
  </Dialog>
  <Dialog
    header="Preavvisi da inviare"
    v-model:visible="dialogFilteredPreavvisi"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '70vw' }"
  >
    <div class="w-full">
      <div class="flex align-items-center mb-3">
        <InputText
          v-model="dialogSearchString"
          @input="onDialogSearch"
          placeholder="Cerca nella tabella..."
          class="w-full uniform-button-height"
        />
      </div>
      <TabView
        v-model:activeIndex="dialogActiveTab"
        v-if="Object.keys(filteredPreavvisiComputed).length !== 0"
      >
        <TabPanel
          v-for="(elements, typeClient) in filteredPreavvisiComputed"
          :key="typeClient"
          :header="typeClient.toUpperCase()"
        >
          <div class="grid my-2">
            <div class="col-12 lg:col-4">
              <div class="card mb-0" style="padding: 12px 20px">
                <div class="flex justify-content-between mb-2">
                  <div>
                    <span class="block text-500 font-medium mb-3"
                      >TOT.FATTURE</span
                    >
                    <div class="text-900 font-medium text-xl">
                      {{
                        formatCurrency(
                          elements.reduce(
                            (acc, curr) => acc + curr.tot_fatture,
                            0
                          )
                        )
                      }}
                    </div>
                  </div>
                  <div
                    class="flex align-items-center justify-content-center bg-blue-100 border-round"
                    style="width: 2rem; height: 2rem"
                  >
                    <i class="pi pi-file text-blue-500 text-m"></i>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 lg:col-4">
              <div class="card mb-0" style="padding: 12px 20px">
                <div class="flex justify-content-between mb-2">
                  <div>
                    <span class="block text-500 font-medium mb-3"
                      >TOT.PAGATO</span
                    >
                    <div class="text-900 font-medium text-xl">
                      {{
                        formatCurrency(
                          elements.reduce(
                            (acc, curr) => acc + curr.tot_pagato,
                            0
                          )
                        )
                      }}
                    </div>
                  </div>
                  <div
                    class="flex align-items-center justify-content-center bg-blue-100 border-round"
                    style="width: 2rem; height: 2rem"
                  >
                    <i class="pi pi-file text-blue-500 text-m"></i>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 lg:col-4">
              <div class="card mb-0" style="padding: 12px 20px">
                <div class="flex justify-content-between mb-2">
                  <div>
                    <span class="block text-500 font-medium mb-3"
                      >TOT.SALDO</span
                    >
                    <div class="text-900 font-medium text-xl">
                      {{
                        formatCurrency(
                          elements.reduce(
                            (acc, curr) => acc + curr.tot_saldo,
                            0
                          )
                        )
                      }}
                    </div>
                  </div>
                  <div
                    class="flex align-items-center justify-content-center bg-blue-100 border-round"
                    style="width: 2rem; height: 2rem"
                  >
                    <i class="pi pi-file text-blue-500 text-m"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Accordion lazy multiple>
            <AccordionTab
              v-for="el in filteredPreavvisiComputed[typeClient]"
              :key="`${el.id}_${typeClient}`"
            >
              <template #header>
                <div class="flex justify-content-between flex-wrap w-full">
                  <div>
                    <span v-if="typeClient == 'agente'">
                      <div>&nbsp;</div>
                      <div>{{ el.agente }}</div>
                    </span>
                    <span v-else>
                      <div class="text-500 text-xs">{{ el.agente }}</div>
                      <div>{{ el.name }}</div>
                    </span>
                    <div class="text-400 text-xs">
                      <small
                        >{{ el.max_giorni_ritardo }} giorni di ritardo</small
                      >
                    </div>
                  </div>
                  <div class="text-left">
                    <div class="price">
                      <small class="text-400 text-xs">SALDO</small>
                      <br />{{ formatCurrency(el.tot_saldo) }}
                    </div>
                    <small class="text-500 text-xs">
                      Fatture scadute ({{ el.details.length }})
                    </small>
                  </div>
                </div>
              </template>

              <DataTable
                :value="el.details"
                responsiveLayout="scroll"
                v-model:selection="selectedItems"
                :rowClass="rowClass"
              >
                <Column selectionMode="multiple" headerStyle="width: 3rem" />
                <Column field="numero" header="N. Fattura"></Column>
                <Column
                  field="is_sent"
                  header="Inviato"
                  :sortable="true"
                ></Column>
                <Column
                  field="notificaPreavvisi"
                  header="Invio Automatico"
                ></Column>

                <Column
                  field="in_suspension"
                  header="Sosp.inviata"
                  :sortable="true"
                >
                  <template #body="{ data }">
                    {{ data.in_suspension == 1 ? "SI" : "NO" }}
                  </template>
                </Column>
                <Column field="data_scadenza" header="Data Scadenza">
                  <template #body="{ data }">
                    {{ moment(data.data_scadenza).format("DD-MM-YYYY") }}
                  </template>
                </Column>
                <Column field="dataInvio" header="Data Invio">
                  <template #body="{ data }">
                    {{
                      data.dataInvio
                        ? moment(data.dataInvio).format("DD-MM-YYYY")
                        : ""
                    }}
                  </template>
                </Column>
                <Column
                  field="cliente"
                  header="Cliente"
                  :sortable="true"
                ></Column>
                <Column
                  field="rappresentante"
                  header="Rappresentante"
                  :sortable="true"
                ></Column>
                <Column field="saldo" header="Totale Fattura"></Column>
                <Column field="saldo" header="Saldo"></Column>
                <Column field="contabili" header="Contabili"></Column>
                <Column field="dilazioni" header="Dilazioni"></Column>
                <Column field="pdp" header="Fornitura"></Column>
              </DataTable>
            </AccordionTab>
          </Accordion>
        </TabPanel>
      </TabView>
    </div>

    <template #footer>
      <div v-show="selectedItems.length > 0" class="btn-selected mb-2">
        <Button
          v-if="!sendingPreavvisi"
          @click="sendPreavvisi"
          class="p-button-warning p-3 m-1"
          style="min-width: 200px"
          :label="`INVIA ORA (${selectedItems.length})`"
          icon="pi pi-send"
          iconPos="right"
        />
        <Button
          v-else
          class="p-button-warning p-3 m-1"
          style="min-width: 200px"
          label="Invio in corso..."
          icon="pi pi-spin pi-spinner"
          disabled
        />
      </div>
      <Button
        label="Seleziona tutto"
        icon="pi pi-check"
        @click="toggleSelectAllPreavvisi"
        class="p-button-success mt-2"
      />
      <Button
        label="Chiudi"
        icon="pi pi-times"
        @click="dialogFilteredPreavvisi = false"
        class="p-button-text mt-2"
      />
    </template>
  </Dialog>
</template>

<script>
import moment from "moment";
import Service from "@/services/ask-management/preavvisi-fatture-clienti-service";
import { ref, getCurrentInstance, watch, computed } from "vue";
import { FilterMatchMode } from "primevue/api";
import Loader from "@/components/Loader.vue";
export default {
  components: {
    Loader,
  },
  setup() {
    const filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    self.$http = self.appContext.config.globalProperties.$http;
    const service = new Service(self.$http, self.$eventBus);
    // const toast = useToast();
    const loader = ref(false);
    const activeTab = ref(0);
    const activeTabName = ref([]);
    const items = ref([]);
    const originalItems = ref([]);
    const filteredItems = ref([]);
    const selectedItems = ref([]);
    const searchString = ref("");
    const search_loaded = ref(false);
    const selectedDate = ref(moment().toDate());
    const dialogCheckPreavvisiSent = ref(false);
    const report = ref();
    const validationErrors = ref({});
    const submitted = ref(false);
    const filterInvii = ref(false);
    const filterSospInviata = ref(false);
    const dialogFilteredPreavvisi = ref(false);
    const filteredPreavvisi = ref([]);
    const filteredPreavvisiCount = ref(0);
    const dialogSearchString = ref("");
    const dialogActiveTab = ref(0);
    const sendingPreavvisi = ref(false);

    const searchData = () => {
      search_loaded.value = false;
      loader.value = true;
      searchString.value = "";

      if (selectedDate.value) {
        let formattedDate = moment(selectedDate.value).format("YYYY-MM-DD");

        service
          .getInsolutiSummary([formattedDate])
          .then((res) => {
            items.value = res.items;
            originalItems.value = res.items;
            activeTabName.value = Object.keys(res.items);
            filteredItems.value = res.items;
            search_loaded.value = true;

            calculateFilteredPreavvisi();
          })
          .finally(() => {
            loader.value = false;
          });
      }
    };

    const onGlobalSearch = () => {
      let tempItems = JSON.parse(JSON.stringify(originalItems.value));
      searchString.value = searchString.value.toLowerCase();
      filters.value.global.value = searchString.value;

      if (searchString.value.length > 0) {
        let filtered = {};
        for (const [key, value] of Object.entries(tempItems)) {
          let filteredElements = value
            .map((els) => {
              let filteredDetails = els.details.filter(
                (el) =>
                  el.numero.toLowerCase().includes(searchString.value) ||
                  (el.agente &&
                    el.agente.toLowerCase().includes(searchString.value)) ||
                  (el.rappresentante &&
                    el.rappresentante
                      .toLowerCase()
                      .includes(searchString.value)) ||
                  (el.cliente &&
                    el.cliente.toLowerCase().includes(searchString.value)) ||
                  (el.pdp && el.pdp.toLowerCase().includes(searchString.value))
              );
              return { ...els, details: filteredDetails };
            })
            .filter((els) => els.details.length > 0);

          if (filteredElements.length > 0) {
            filtered[key] = filteredElements;
          }
        }
        filteredItems.value = filtered;
      } else {
        filteredItems.value = tempItems;
      }
    };

    const sendPreavvisi = () => {
      sendingPreavvisi.value = true;
      dialogCheckPreavvisiSent.value = false;
      loader.value = true;

      service
        .sendPreavvisi(selectedItems.value)
        .then((res) => {
          selectedItems.value = [];
          dialogCheckPreavvisiSent.value = true;
          report.value = res.items;
        })
        .finally(() => {
          loader.value = false;
          sendingPreavvisi.value = false;
        });
    };

    const onGetPdfButton = (numero) => {
      service.downloadFilePreavvisiZip({
        "fattura_vendita.numeri": [numero],
      });
    };

    // const validateContacts = () => {
    //   let isValid = selectedItems.value.every((el) => el.pec || el.email);
    //   return isValid;
    // };

    const formatCurrency = (value) => {
      return value.toLocaleString("it-IT", {
        style: "currency",
        currency: "EUR",
      });
    };

    const exportCSV = (month) => {
      self.refs[`dt_insoluti_${month}`].exportCSV();
    };

    const toggleOverlay = (event, numero) => {
      self.refs[`overlay_${numero}`].toggle(event);
    };

    const rowClass = (data) => {
      return [
        { "bg-pink-100": !data.pec && !data.email },
        { "bg-green-100": data.is_sent === "SI" },
        { "bg-red-100": data.is_sent !== "SI" },
      ];
    };

    const filteredDetails = (details) => {
      let filtered = details;
      if (filterInvii.value) {
        filtered = filtered.filter((detail) => detail.is_sent === "NO");
      }
      if (filterSospInviata.value) {
        filtered = filtered.filter((detail) => detail.in_suspension != 1);
      }
      if (searchString.value) {
        filtered = filtered.filter(
          (el) =>
            el.numero.toLowerCase().includes(searchString.value) ||
            (el.agente &&
              el.agente.toLowerCase().includes(searchString.value)) ||
            (el.rappresentante &&
              el.rappresentante.toLowerCase().includes(searchString.value)) ||
            (el.cliente &&
              el.cliente.toLowerCase().includes(searchString.value)) ||
            (el.pdp && el.pdp.toLowerCase().includes(searchString.value))
        );
      }
      return filtered;
    };

    const toggleFilterInvii = () => {
      filterInvii.value = !filterInvii.value;
      applyFilters();
    };

    const toggleFilterSospInviata = () => {
      filterSospInviata.value = !filterSospInviata.value;
      applyFilters();
    };

    const applyFilters = () => {
      let tempItems = JSON.parse(JSON.stringify(originalItems.value));
      let filtered = {};

      for (const [key, value] of Object.entries(tempItems)) {
        let filteredElements = value
          .map((els) => {
            let filteredDetails = els.details.filter((el) => {
              let match = true;

              if (filterInvii.value) {
                match = match && el.is_sent === "NO";
              }

              if (filterSospInviata.value) {
                match = match && el.in_suspension != 1;
              }

              if (searchString.value) {
                const search = searchString.value.toLowerCase();
                match =
                  match &&
                  (el.numero.toLowerCase().includes(search) ||
                    (el.agente && el.agente.toLowerCase().includes(search)) ||
                    (el.rappresentante &&
                      el.rappresentante.toLowerCase().includes(search)) ||
                    (el.cliente && el.cliente.toLowerCase().includes(search)) ||
                    (el.pdp && el.pdp.toLowerCase().includes(search)));
              }

              return match;
            });

            return { ...els, details: filteredDetails };
          })
          .filter((els) => els.details.length > 0);

        if (filteredElements.length > 0) {
          filtered[key] = filteredElements;
        }
      }

      filteredItems.value = filtered;
      calculateFilteredPreavvisi();
    };

    const showFilteredPreavvisi = () => {
      const now = moment();
      const filtered = {};
      let count = 0;

      for (const [key, value] of Object.entries(items.value)) {
        let filteredElements = value
          .map((els) => {
            let filteredDetails = els.details.filter((el) => {
              const scadenza = moment(el.data_scadenza);
              return now.diff(scadenza, "days") > 0 && el.is_sent === "NO";
            });

            count += filteredDetails.length;

            return { ...els, details: filteredDetails };
          })
          .filter((els) => els.details.length > 0);

        if (filteredElements.length > 0) {
          filtered[key] = filteredElements;
        }
      }

      filteredPreavvisi.value = filtered;
      filteredPreavvisiCount.value = count;
      dialogFilteredPreavvisi.value = true;
    };

    const calculateFilteredPreavvisi = () => {
      const now = moment();
      const filtered = {};
      let count = 0;

      for (const [key, value] of Object.entries(items.value)) {
        let filteredElements = value
          .map((els) => {
            let filteredDetails = els.details.filter((el) => {
              const scadenza = moment(el.data_scadenza);
              let match = now.diff(scadenza, "days") > 0;
              if (filterInvii.value) {
                match = match && el.is_sent === "NO";
              }
              if (filterSospInviata.value) {
                match = match && el.in_suspension != 1;
              }
              return match;
            });

            count += filteredDetails.length;

            return { ...els, details: filteredDetails };
          })
          .filter((els) => els.details.length > 0);

        if (filteredElements.length > 0) {
          filtered[key] = filteredElements;
        }
      }

      filteredPreavvisi.value = filtered;
      filteredPreavvisiCount.value = count;
    };

    const selectAllPreavvisi = () => {
      selectedItems.value = [];

      for (const value of Object.values(filteredPreavvisi.value)) {
        value.forEach((els) => {
          selectedItems.value.push(...els.details);
        });
      }
    };

    const onDialogSearch = () => {
      const search = dialogSearchString.value.toLowerCase();

      if (!search) {
        filteredPreavvisi.value = JSON.parse(
          JSON.stringify(originalItems.value)
        );
      } else {
        const filtered = {};
        for (const [key, value] of Object.entries(originalItems.value)) {
          const filteredElements = value
            .map((els) => {
              const filteredDetails = els.details.filter(
                (detail) =>
                  detail.numero.toLowerCase().includes(search) ||
                  (detail.cliente &&
                    detail.cliente.toLowerCase().includes(search)) ||
                  (detail.agente &&
                    detail.agente.toLowerCase().includes(search)) ||
                  (detail.rappresentante &&
                    detail.rappresentante.toLowerCase().includes(search))
              );
              return { ...els, details: filteredDetails };
            })
            .filter((els) => els.details.length > 0);

          if (filteredElements.length > 0) {
            filtered[key] = filteredElements;
          }
        }
        filteredPreavvisi.value = filtered;
      }
    };

    const toggleSelectAllPreavvisi = () => {
      const now = moment();

      if (selectedItems.value.length > 0) {
        selectedItems.value = [];
      } else {
        for (const value of Object.values(filteredPreavvisi.value)) {
          value.forEach((els) => {
            const validDetails = els.details.filter((el) => {
              const scadenza = moment(el.data_scadenza);
              return now.diff(scadenza, "days") > 0 && el.is_sent === "NO";
            });

            selectedItems.value.push(...validDetails);
          });
        }
      }
    };

    const allPreavvisiCount = () => {
      let count = 0;
      for (const value of Object.values(filteredPreavvisi.value)) {
        count += value.reduce((acc, els) => acc + els.details.length, 0);
      }
      return count;
    };

    const filteredPreavvisiComputed = computed(() => {
      const search = dialogSearchString.value.toLowerCase();

      const filtered = {};

      for (const [key, value] of Object.entries(filteredPreavvisi.value)) {
        let filteredElements = value
          .map((els) => {
            let filteredDetails = els.details.filter((detail) => {
              let match = true;
              if (filterInvii.value) {
                match = match && detail.is_sent.length === "NO";
              }
              if (filterSospInviata.value) {
                match = match && detail.in_suspension != 1;
              }
              if (search.length > 0) {
                match =
                  match &&
                  (detail.numero.toLowerCase().includes(search) ||
                    (detail.cliente &&
                      detail.cliente.toLowerCase().includes(search)) ||
                    (detail.agente &&
                      detail.agente.toLowerCase().includes(search)) ||
                    (detail.rappresentante &&
                      detail.rappresentante.toLowerCase().includes(search)));
              }
              return match;
            });

            return { ...els, details: filteredDetails };
          })
          .filter((els) => els.details.length > 0);

        if (filteredElements.length > 0) {
          filtered[key] = filteredElements;
        }
      }

      return filtered;
    });

    watch(dialogSearchString, () => {
      onDialogSearch();
    });
    watch(filterInvii, applyFilters);
    watch(filterSospInviata, applyFilters);
    watch(searchString, applyFilters);
    watch(dialogSearchString, onDialogSearch);

    return {
      toggleOverlay,
      exportCSV,
      rowClass,
      moment,
      selectedDate,
      activeTab,
      items,
      originalItems,
      filteredItems,
      selectedItems,
      loader,
      filters,
      searchData,
      formatCurrency,
      validationErrors,
      submitted,
      searchString,
      onGlobalSearch,
      sendPreavvisi,
      dialogCheckPreavvisiSent,
      report,
      onGetPdfButton,
      filterInvii,
      filteredDetails,
      toggleFilterInvii,
      filterSospInviata,
      toggleFilterSospInviata,
      search_loaded,
      dialogFilteredPreavvisi,
      filteredPreavvisi,
      showFilteredPreavvisi,
      filteredPreavvisiCount,
      selectAllPreavvisi,
      onDialogSearch,
      toggleSelectAllPreavvisi,
      allPreavvisiCount,
      dialogSearchString,
      dialogActiveTab,
      filteredPreavvisiComputed,
    };
  },
};
</script>
<style scoped>
.preavvisi {
  box-shadow: none !important;
}
.custom-button {
  padding: 9px 41px; /* Riduci il padding per rendere il pulsante più piccolo */
  border-radius: 30px; /* Maggiore raggio per un bordo più arrotondato */
  font-size: 14px;
  background-color:#ec9929;
  border: none;
}
.custom-button:hover {
background-color: #bf7d24;
}
.btn-selected {
  position: fixed;
  bottom: 60px;
  right: 40px;
  z-index: 2;
}

.uniform-button-height {
  height: 30px;
}
</style>

